import { useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { List, ListItem, ListItemIcon, ListItemText, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useForm_GetNextFormQuery } from 'queries';

import { NotificationSeverity, showAlert } from 'utils/notification-manager';

import EstateModuleModal from './estate-module-modal';

const useStyles = makeStyles((theme) => ({
  title: {
    fontWeight: 600,
  },
  rootContainer: {
    marginTop: '20px',
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      height: 'auto',
    },
    background: '#FFFFFF',
    justifyContent: 'center',
    boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.25)',
    borderRadius: '2px',
  },
  listContainer: {
    overflow: 'auto',
  },
  listItem: {
    width: '95%',
    margin: 'auto',
    background: '#F1FCFF',
    boxSizing: 'border-box',
    boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.25)',
    borderRadius: '2px',
    marginBottom: '20px',
    marginTop: '20px',
    paddingTop: '25px',
    paddingBottom: '25px',
  },
  buttonMainText: {
    color: '#096094',
    fontWeight: 600,
  },
  buttonText: {
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '16px',
    lineHeight: '20px',
  },
}));

const GetStarted = () => {
  const history = useHistory();
  const { portalId } = useParams<Record<string, string>>();
  const { data: nextFormData, loading: nextFormLoading } = useForm_GetNextFormQuery({
    fetchPolicy: 'network-only',
    notifyOnNetworkStatusChange: true,
    variables: {
      portalId,
    },
    onError: (e) => {
      showAlert({
        message: 'Error getting next form: ' + e.message,
        severity: NotificationSeverity.ERROR,
      });
    },
  });
  const classes = useStyles();
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <EstateModuleModal
        showModal={showModal}
        setShowModal={setShowModal}
        onActionClick={() => {}}
        onExitClick={() => setShowModal(false)}
      />
      <Typography className={classes.title} variant="h4">
        Get Started
      </Typography>
      <div className={classes.rootContainer}>
        <List className={classes.listContainer}>
          {nextFormData && !nextFormLoading && nextFormData.data.order !== -1 && (
            <ListItem
              button
              className={classes.listItem}
              disableRipple
              onClick={() => setShowModal(true)}
              data-cy="complete-estate-module"
            >
              <ListItemIcon>
                <img src="/estate-module.svg" alt="estate-module" />
              </ListItemIcon>
              <ListItemText
                primary={
                  <Typography variant="h6" className={classes.buttonMainText}>
                    Step 1: Complete the Estate Module
                  </Typography>
                }
                secondary={
                  <Typography variant="subtitle1">
                    Answer a few questions about the estate to get started.
                  </Typography>
                }
              />
            </ListItem>
          )}
          <ListItem
            button
            className={classes.listItem}
            disableRipple
            onClick={() => {
              history.push(`/home/${portalId}/letters-and-forms/sign`);
            }}
          >
            <ListItemIcon>
              <img src="/form.svg" alt="Letters and Forms" />
            </ListItemIcon>
            <ListItemText
              className={classes.buttonText}
              primary="Sign Letters and Forms"
              id="sign-letters-and--forms-button"
            />
          </ListItem>
        </List>
      </div>
    </>
  );
};
export default GetStarted;
